import React, { useEffect } from 'react';
import './Index.css';
import { Box, Stack } from '@mui/material';
import HttpService from '../../services/HttpService';
import Constants from '../../utils/constants';
import { useStore } from '../../utils/store';
import { setStoredMenuItems } from '../../utils/storageUtil';
import AlertMessageComponent from '../../components/AlertMessageComponent';
import { useAlert } from '../../components/alertContext';
const Dashboard: React.FC = () => {
  // const isInitialLoad = useRef(true);
  useEffect(() => {
    document.getElementsByTagName('body')[0].classList.remove('loginbody');
    //  if (isInitialLoad.current) {
    // isInitialLoad.current = false;
    fetchBundleData();
    // }
  }, []);
  const { getAdmin, setLoumacMenuItems } = useStore();
  const { alert, setAlert, handleCloseAlert } = useAlert();

  const fetchBundleData = async () => {
    try {
      const response = await HttpService.get(
        `${Constants.apiURL + Constants.refBundleURL}/fetchForms`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        null
      );
      console.log(response);
      if (response.data) {
        setStoredMenuItems(response.data);
        setLoumacMenuItems(response.data);
      } else {
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  return (
    <Stack>
      <Box className="main dashboardmain">
        <section className="section dashboard">
          <div className="row">
            <div className="col-lg-8"></div>
          </div>
        </section>
      </Box>
      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={handleCloseAlert}
        message={alert.message}
      />{' '}
    </Stack>
  );
};

export default Dashboard;
